import axios from 'axios';
import { aadConfig, getAccessToken } from '../aad';
import type { AIReviewHistory } from '../dto/ai';
import apiProxy from './apiProxy';

export const getAIReviewHistory = apiProxy(
  'getAIReviewHistory',
  async (accountId: string, projectId?: string): Promise<AIReviewHistory[]> => {
    await getAccessToken(aadConfig().accountScopes);

    const p = projectId ? [`projectId=${projectId}`] : [];

    const { data } = await axios.get(
      `${process.env.AI_HOST}/v1/accounts/${accountId}/ai/review-history${p.length ? `?${p.join('&')}` : ''}`,
    );
    return data;
  },
);

/**
 * One AI content document, parsed as JSON.
 *
 * The route is account scoped and the store is keyed by account, so a
 * content id belonging to another account does not resolve here.
 */
export const getAIContentJson = apiProxy(
  'getAIContentJson',
  async <T,>(accountId: string, contentId: string): Promise<T> => {
    await getAccessToken(aadConfig().contentScopes);

    const { data } = await axios.get<T>(
      `${process.env.CONTENT_API}/accounts/${accountId}/ai/content/${contentId}`,
      // The service streams the file with its stored content type. Asking
      // for text and parsing here keeps that working whether it is sent as
      // application/json or as a plain octet stream.
      { responseType: 'text', transformResponse: [(raw: string) => (raw ? JSON.parse(raw) : null)] },
    );
    return data;
  },
);
